import React from 'react';
import PropTypes from 'prop-types';

import { StyledBtn } from './ClearAllBtnStyles';

var ClearAllBtn = function ClearAllBtn(props) {
  return React.createElement(
    StyledBtn,
    { onClick: props.onClick },
    'Clear All'
  );
};

ClearAllBtn.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default ClearAllBtn;